import React from "react";
import "../../SecuritySchoolsComponents/TabCard.css";
import Link from '@mui/material/Link';
import {Breadcrumbs} from "@material-ui/core";

function InfrastructureSecurity() {
  return (
    <>
    <div className="tabCard-content">
    <div className="SSA-row flexCenter">
        <div className="SSA-box">
            <Link to={'/Tufin'} className="calendar-link">
                <img src="images/SecuritySchools/TufinFoundationSchool/Tufin-Card.png" alt="SSA-img" className="SSA-img" />
                <div className="SSA-box-content">
                    <h3>Tufin​</h3>
                    <p>Tufin enables network and cloud security policy management based on application needs. Tufin monitors the configurations of firewalls, routers, load balancers, and cloud platforms.</p>
                    <a href="/Tufin">Learn more</a>
                </div>
            </Link>
        </div>
      </div>
    </div>
    </>
  );
}

export default InfrastructureSecurity;
